import { HONEY, beeInner } from '../components/bees/beeSvg';

const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

function scrollParent(el) {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = window.getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
  }
  return null;
}

/** A short honey glow on the row and a bee that flies across it, then both are gone. */
function greet(row, delay) {
  window.setTimeout(() => {
    row.classList.remove('bb-arrive');
    void row.offsetWidth;  // restart the glow when the same row is greeted again
    row.classList.add('bb-arrive');
    window.setTimeout(() => row.classList.remove('bb-arrive'), 1700);
    if (reducedMotion()) return;
    const bee = document.createElement('span');
    bee.className = 'bb-arrive-bee';
    bee.setAttribute('aria-hidden', 'true');
    bee.style.setProperty('--bb-fly', `${Math.max(row.clientWidth - 22, 40)}px`);
    bee.innerHTML = `<svg viewBox="0 0 120 120" width="18" height="18" class="bb-bee bb-bee--work" style="overflow:visible;display:block">${beeInner({ color: HONEY, state: 'work', uid: 'arrive' })}</svg>`;
    row.appendChild(bee);
    window.setTimeout(() => bee.remove(), 1300);
  }, delay);
}

/**
 * Brings the open project's row into view in the sidebar, the way VS Code's explorer
 * reveals the active file (explorerView.ts: `tree.reveal(item, 0.5)` only when the item
 * is not visible): a row already on screen stays where it is, any other one comes to the
 * middle. With `greet`, the row lights up and a bee flies across it, so it is clear where
 * the work moved.
 */
export function revealSidebarProject(id, opts = {}) {
  revealSidebarRow('data-sidebar-project', id, opts);
}

/** The same for the open document's row (under its project and folders). */
export function revealSidebarDocument(id, opts = {}) {
  revealSidebarRow('data-sidebar-doc', id, opts);
}

function revealSidebarRow(attr, id, { greet: withGreeting = true } = {}) {
  const rows = document.querySelectorAll(`[${attr}="${window.CSS.escape(id)}"]`);
  const row = [...rows].find((el) => el.offsetParent !== null);
  if (!row) return;
  const box = scrollParent(row);
  let moved = false;
  if (box) {
    const r = row.getBoundingClientRect();
    const b = box.getBoundingClientRect();
    if (r.top < b.top || r.bottom > b.bottom) {
      box.scrollTo({ top: box.scrollTop + (r.top - b.top) - (b.height - r.height) / 2, behavior: reducedMotion() ? 'auto' : 'smooth' });
      moved = true;
    }
  }
  if (withGreeting) greet(row, moved ? 380 : 0);
}
